// frontend/src/components/SearchBar.jsx
import { useEffect, useState } from "react";

export default function SearchBar({ onSearch, loading, defaultType = "company", initial = {}, onOpenAdvanced, filterCount = 0 }) {
  const [q, setQ] = useState(initial.q || "");
  const [country, setCountry] = useState(initial.country || "");

  useEffect(() => {
    setQ(initial.q || "");
    setCountry(initial.country || "");
  }, [initial.q, initial.country]);

  const submit = () => {
    onSearch({
      q,
      country,
      type: defaultType,
      page: 1,
    });
  };

  return (
    <div style={{ display: "flex", gap: 12, alignItems: "center", flexWrap: "wrap", marginBottom: 16 }}>
      <input
        aria-label="Search companies"
        value={q}
        onChange={(e) => setQ(e.target.value)}
        placeholder="Search name, reg no, IC name, aliases, related persons…"
        style={{
          flex: 1,
          minWidth: 320,
          height: 42,
          padding: "0 12px",
          borderRadius: 10,
          border: "1px solid var(--border-primary)",
          background: "var(--surface)",
          color: "var(--text-primary)",
        }}
      />

      <input
        aria-label="Filter by country"
        value={country}
        onChange={(e) => setCountry(e.target.value)}
        placeholder="Country (name or ISO2)"
        style={{
          width: 220,
          height: 42,
          padding: "0 12px",
          borderRadius: 10,
          border: "1px solid var(--border-primary)",
          background: "var(--surface)",
          color: "var(--text-primary)",
        }}
      />

      <button
        type="button"
        onClick={submit}
        disabled={loading}
        style={{
          height: 42,
          padding: "0 14px",
          borderRadius: 10,
          border: "none",
          background: "var(--accent-primary)",
          color: "#fff",
          fontWeight: 700,
          cursor: loading ? "not-allowed" : "pointer",
          opacity: loading ? 0.7 : 1,
        }}>
        {loading ? "Searching…" : "Search"}
      </button>

      <button
        type="button"
        onClick={onOpenAdvanced}
        style={{
          height: 42,
          padding: "0 14px",
          borderRadius: 10,
          border: "1px solid var(--border-primary)",
          background: "var(--surface)",
          color: "var(--text-secondary)",
          fontWeight: 700,
          cursor: "pointer",
          display: "inline-flex",
          alignItems: "center",
          gap: 8,
        }}>
        Advanced Filters {filterCount > 0 ? `(${filterCount})` : ""}
      </button>
    </div>
  );
}
